import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
const FinalCTA = () => {
  return <section className="py-20 bg-primary-gradient" data-id="element-53">
      <div className="container" data-id="element-54">
        <div className="max-w-4xl mx-auto text-center" data-id="element-55">
          {/* Urgency Banner */}
          <div className="inline-block bg-white text-settl-blue font-medium px-4 py-2 rounded-full mb-8 shadow-md" data-id="element-56">
            <span className="inline-flex items-center" data-id="element-57">
              <span className="bg-alert-orange h-2 w-2 rounded-full mr-2 animate-pulse" data-id="element-58"></span>
              Limited Time: Get 3 months at 50% off when you sign up today
            </span>
          </div>
          <h2 className="font-outfit font-bold text-3xl md:text-4xl text-white mb-6" data-id="element-59">
            Ready to Transform Your Bill Payments?
          </h2>
          <p className="text-white text-opacity-90 text-lg mb-8 max-w-2xl mx-auto" data-id="element-60">
            Join 500+ Malaysian businesses that are saving time, improving cash
            flow, and eliminating payment headaches with Settl.
          </p>
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-12" data-id="element-61">
            <a href="https://wa.me/60127743934/?text=I%20am%20interested%20in%20Settl" className="bg-white text-settl-blue font-medium py-4 px-8 rounded-lg hover:bg-blue-50 transition-all duration-300 shadow-lg" data-id="element-62">
              Start Free Trial
            </a>
            <a href="https://wa.me/60127743934/?text=I%20am%20interested%20in%20Settl" className="bg-transparent text-white border-2 border-white font-medium py-4 px-8 rounded-lg hover:bg-white/10 transition-all duration-300 flex items-center justify-center" data-id="element-63">
              Schedule Demo
              <ArrowRight className="h-5 w-5 ml-2" data-id="element-64" />
            </a>
          </div>
          {/* Trust Elements */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 max-w-3xl mx-auto" data-id="element-65">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-66">
              <div className="flex items-center justify-center" data-id="element-67">
                <CheckCircle className="h-5 w-5 text-white mr-2" data-id="element-68" />
                <span className="text-white text-sm" data-id="element-69">No setup fees</span>
              </div>
              <div className="flex items-center justify-center" data-id="element-70">
                <CheckCircle className="h-5 w-5 text-white mr-2" data-id="element-71" />
                <span className="text-white text-sm" data-id="element-72">Cancel anytime</span>
              </div>
              <div className="flex items-center justify-center" data-id="element-73">
                <CheckCircle className="h-5 w-5 text-white mr-2" data-id="element-74" />
                <span className="text-white text-sm" data-id="element-75">
                  Free onboarding support
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default FinalCTA;